import { gdprAccepted, gdprDeclined, LISTEN_FOR_CONSENT } from '../redux/gdpr';

const gdprMiddleware = ({ dispatch }) => next => action => {
  if (action.type !== LISTEN_FOR_CONSENT) {
    return next(action);
  }

  const handleConsent = (e: any) => {
    window.removeEventListener('consent', handleConsent);
    e.detail.consent ? dispatch(gdprAccepted()) : dispatch(gdprDeclined());
  };

  window.addEventListener('consent', handleConsent);
};

export default gdprMiddleware;
